import { getStorage } from './storage'

const getLocalKeyWords = (key) => {
  const localKeywords = JSON.parse(getStorage('keywords'))
  if (localKeywords !== null && localKeywords !== undefined) {
    return localKeywords[key]
  }
}

export default getLocalKeyWords